import React from 'react'
import Teams from '../AboutUs/Teams'
import Footer from '../Footer/Footer'

const Team = () => {
  return (
    <>
    <div className='bg-black h-28'></div>
    <Teams/>
    <Footer/>
    </>
  )
}

export default Team